import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import Layout from "./containers/Layout";
import PatientLanding from "./pages/PatientLanding";
// import PatientRegistrationForm from "./pages/PatientRegistrationForm";
import AppointmentConfirmation from "./pages/AppointmentConfirmation";
import { isAuthenticatedPat } from "./utils/commonUtils";
import OtpSection from "./components/commonSubCom/OtpSection";
import FamilyList from "./components/FamilyListPage";
import AddFamilyMember from "./pages/AddFamilyMember";
import OtpVerificationSection from "./components/commonSubCom/OtpVerificationSection";
import Profile from "./pages/Profile";
import Appointments from "./pages/Appointments";

const ProtectedRoute = ({ element, path }) => {
  return isAuthenticatedPat() ? (
    <Layout>{element}</Layout>
  ) : (
    <Navigate to="/patient/verification" state={{ from: path }} />
  );
};

const RedirectToLoginOrForm = () => {
  const location = useLocation();
  const { doctorNameProps = null } = location?.state ?? {};
  const queryParams = new URLSearchParams(location.search);

  const clinicId = queryParams.get("clinicId") || null;
  const doctorId = queryParams.get("doctorId") || null;

  const redirectUrl =
    clinicId == null && doctorId == null
      ? `/patient/?clinicId=${clinicId}&doctorId=${doctorId}`
      : `/patient/familylist`;

  if (clinicId && !doctorId) {
    return <PatientLanding />;
  } else if (clinicId && doctorId) {
    const res = isAuthenticatedPat();

    if (res) {
      localStorage.removeItem("pat-clinic-doctor");
    }

    localStorage.setItem(
      "pat-clinic-doctor",
      JSON.stringify({
        doctorId: doctorId,
        clinicId: clinicId,
        doctorName: doctorNameProps,
      })
    );

    return res ? (
      <Navigate
        to="/patient/familylist"
        state={{
          url: redirectUrl,
          doctorIdProps: doctorId,
          clinicIdProps: clinicId,
          doctorNameProps,
        }}
      />
    ) : (
      <Navigate
        to="/patient/verification"
        state={{
          url: redirectUrl,
          doctorIdProps: doctorId,
          clinicIdProps: clinicId,
          doctorNameProps,
        }}
      />
    );

    //return <PatientRegistrationForm clinicId={clinicId} doctorId={doctorId} />;
  } else {
    return <Navigate to="/patient/familylist" state={{}} />;
  }
};
// { path: "/appointmentConfirmation", element: <ProtectedRoute element={<AppointmentConfirmation />} />},
export function PatientRoutes() {
  const routes = [
    {
      path: "/familylist/add",
      element: <ProtectedRoute element={<AddFamilyMember />} />,
    },
    {
      path: "/familylist",
      element: <ProtectedRoute element={<FamilyList />} />,
    },
    {
      path: "/appointments",
      element: <ProtectedRoute element={<Appointments />} />,
    },
    {
      path: "/profile",
      element: <ProtectedRoute element={<Profile />} />,
    },
  ];

  return (
    <Routes>
      <Route path="/verification/otp" element={<OtpVerificationSection />} />
      <Route path="/verification" element={<OtpSection />} />

      {routes.map(({ path, element }) => (
        <Route key={path} path={path} element={element} />
      ))}
      <Route path="/" element={<RedirectToLoginOrForm />} />
      <Route
        path="*"
        element={<Navigate to="/404" state={{ from: "patient" }} />}
      />
    </Routes>
  );
}
